import Container from "@mui/material/Container"
import { Providers } from "./providers/Providers"
import Hiring from "../pages/hiring/Index"
import { Routing } from "../pages/Routing"
import Header from "../pages/header/Header"

function App() {
  return (
    <>
      <Header />
      <Routing />
    </>
  )
}

export default Providers(App)
